import { ReportsService } from '@/services/reports/reports.service';
import { StoreState } from '@/store';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { dateToString, dateTimeToString } from '@/utils/dateToString';
import { exportToExcel } from '@/utils/exportToExcel';
import { dateEndMustBeAfterDateStart } from '@/validators/dateEndMustBeAfterDateStart';
import { dateMustBeBeforeOrEqualThanToday } from '@/validators/dateMustBeBeforeOrEqualThanToday';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { GetReportInfringements, MultipleIdListToFilter, ResponseFilterInfringements, ResponseInfringementsExcel, SelectedListToFilter } from '../../../../interfaces/reports/reports';
import { dateRangeConstraintByMonths, oneMustBeActiveOneOfEach } from '../reports.validators';

type ListShape = {
  id: number;
  name: string;
  active: boolean;
  entryId: number;
}

@Component({
  selector: 'app-reports-infractions',
  templateUrl: './infractions.component.html',
  styleUrls: ['./infractions.component.css'],
})
export class InfractionsComponent implements OnInit {
  @Input() assetList: SelectedListToFilter[] = [];
  @Input() resetFormControl: Subject<boolean> = new Subject<boolean>();
  @Input() assetIdSelectedControl = new FormControl([]);

  @Input() zonesList: MultipleIdListToFilter[] = [];
  @Input() severityInfractionsList: MultipleIdListToFilter[] = [];
  @Input() typeSanctionList: MultipleIdListToFilter[] = [];

  @Input() gettingItemsList: boolean = true;
  @Input() gettingItemsListError: string = 'DEFAULT_VALUE';

  @Input() gettingZoneList: boolean = true;
  @Input() gettingSeverityList: boolean = true;
  @Input() gettingSanctionList: boolean = true;

  gettingDetailsLicense: boolean = false;
  gettingLDetailsLicenseError: string = 'DEFAULT_VALUE';
  warning: boolean = false;
  assetId: number = 1;
  isRequestInfractionsReport: boolean = false;
  pageCount: number = 0;
  listCountForPages: number[] = [];
  currentPage: number = 0;

  detailInfractionsByFilter?: ResponseFilterInfringements[];

  listFilterAllAsset: FormControl = new FormControl();
  listFilterAllZones: FormControl = new FormControl();
  listFilterAllSeverity: FormControl = new FormControl();
  listFilterAllSanctions: FormControl = new FormControl();

  assetsListsControl: FormArray = new FormArray([]);
  zonesListsControl: FormArray = new FormArray([]);
  severityInfractionsListsControl: FormArray = new FormArray([]);
  sanctionTypeListsControl: FormArray = new FormArray([]);
  filterResult: string = 'infractions';
  controlForm: FormGroup = new FormGroup({});

  lastSubmitData?: GetReportInfringements;

  get pageNumberSelected(): FormControl {
    return this.controlForm.controls.pageNumberSelected as FormControl;
  }
  get dateFromReport(): FormControl {
    return this.controlForm.controls.fromDayReport as FormControl;
  }
  get dateUntilReport(): FormControl {
    return this.controlForm.controls.untilDayReport as FormControl;
  }
  get listFilterControlAsset(): FormArray {
    return this.controlForm.controls.listFilterControlAsset as FormArray;
  }
  // validaciones  calendarios

  get controlDateStartError(): string {
    const error = this.controlForm.controls.fromDayReport.errors;
    if (error) return error.description;
    return '';
  }
  // validaciones  calendarios

  get controlDateEndError(): string {
    const error = this.controlForm.errors;
    if (error && !error.hidden) return error.description;
    return '';
  }
  constructor(
    private reportsServices: ReportsService,
    private store: Store<StoreState>,
  ) { }

  ngOnInit(): void {

    this.controlForm = new FormGroup({
      fromDayReport: new FormControl(null, [Validators.required, dateMustBeBeforeOrEqualThanToday()]),
      untilDayReport: new FormControl(null, [Validators.required]),
      listFilterControlAsset: this.assetsListsControl,
      listFilterControlZones: this.zonesListsControl,
      listFilterControlSeverityInfractions: this.severityInfractionsListsControl,
      listFilterControlSanctionTypes: this.sanctionTypeListsControl,
      pageNumberSelected: new FormControl(1),
    }, [
      dateEndMustBeAfterDateStart('fromDayReport', 'untilDayReport'),
      oneMustBeActiveOneOfEach('listFilterControlAsset', 'listFilterControlZones', 'listFilterControlSeverityInfractions', 'listFilterControlSanctionTypes'),
      dateRangeConstraintByMonths('fromDayReport', 'untilDayReport', 30),
    ]);

    let defaultValueWasSetted = false;
    this.assetsListsControl.valueChanges.subscribe({
      next: (value: ListShape[]) => {
        if (!defaultValueWasSetted) {
          defaultValueWasSetted = true;
          for (
            let index = 0;
            index < this.assetsListsControl.controls.length;
            index++
          ) {
            const formControl = this.assetsListsControl.at(index);
            if (index === 0) {
              formControl.patchValue({ active: true });
            } else {
              formControl.patchValue({ active: false });
            }
          }
        }
        this.onCheckAssetChange(value);

      },
    });

    this.listFilterAllAsset.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.assetsListsControl.controls.length;
          index++
        ) {
          const formControl = this.assetsListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.listFilterAllZones.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.zonesListsControl.controls.length;
          index++
        ) {
          const formControl = this.zonesListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.listFilterAllSeverity.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.severityInfractionsListsControl.controls.length;
          index++
        ) {
          const formControl = this.severityInfractionsListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.listFilterAllSanctions.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.sanctionTypeListsControl.controls.length;
          index++
        ) {
          const formControl = this.sanctionTypeListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.resetFormControl.subscribe((response) => {
      if (response) {
        this.controlForm.patchValue({
          fromDayReport: null,
          untilDayReport: null,
        });

        const defaultControl = this.assetsListsControl.at(0);
        defaultControl.patchValue({ active: true });
        for (
          let index = 1;
          index < this.assetsListsControl.controls.length;
          index++
        ) {
          const control = this.assetsListsControl.at(index);
          control.patchValue({ active: false });
        }
        for (
          let index = 0;
          index < this.zonesListsControl.controls.length;
          index++
        ) {
          const control = this.zonesListsControl.at(index);
          control.patchValue({ active: false });
        }
        for (
          let index = 0;
          index < this.severityInfractionsListsControl.controls.length;
          index++
        ) {
          const control = this.severityInfractionsListsControl.at(index);
          control.patchValue({ active: false });
        }
        for (
          let index = 0;
          index < this.sanctionTypeListsControl.controls.length;
          index++
        ) {
          const control = this.sanctionTypeListsControl.at(index);
          control.patchValue({ active: false });
        }

        this.isRequestInfractionsReport = false;
      }
    });
  }

  onGetDetailReport(formDataReport?: GetReportInfringements) {
    this.gettingDetailsLicense = true;
    const formData = this.controlForm.value;
    const selectedAsset = formData.listFilterControlAsset.filter((value: any) => value.active);
    const selectedZones = formData.listFilterControlZones.filter((value: any) => value.active);
    const selectedSeverity = formData.listFilterControlSeverityInfractions.filter((value: any) => value.active);
    const selectedTypesSanctions = formData.listFilterControlSanctionTypes.filter((value: any) => value.active);

    if (
      selectedAsset.length > 0 ||
      selectedZones.length > 0 ||
      selectedSeverity.length > 0 ||
      selectedTypesSanctions.length > 0
    ) {
      const assetFiltered = selectedAsset.map((item: SelectedListToFilter) => ({
        id: item.id,
      }));
      const zoneFiltered = selectedZones.map((item: SelectedListToFilter) => ({
        id: item.id,
      }));
      const severityFiltered = selectedSeverity.map(
        (item: SelectedListToFilter) => ({ id: item.id })
      );
      const sanctionFiltered = selectedTypesSanctions.map(
        (item: SelectedListToFilter) => ({ id: item.id })
      );
      let getFormDataReport: GetReportInfringements = {
        dateStart: formData.fromDayReport,
        dateEnd: formData.untilDayReport,
        assets: assetFiltered,
        zones: zoneFiltered,
        infringementsTypes: severityFiltered,
        infringementsSanctions: sanctionFiltered,
        pageNumber: formData.pageNumberSelected,
      };

      this.lastSubmitData = getFormDataReport;
      if (formDataReport) {
        getFormDataReport = formDataReport;
      }
      this.currentPage = <number>this.lastSubmitData?.pageNumber;

      this.reportsServices
        .getReportInfringements(this.lastSubmitData)
        .subscribe({
          next: (res) => {
            this.detailInfractionsByFilter = res;
            if (res[0]) {
              this.pageCount = <number>res[0].pageCount;
            }
            this.getListNumberCount(this.pageCount);
            this.gettingDetailsLicense = false;
            this.isRequestInfractionsReport = true;
          },
          error: () => {
            this.store.dispatch(loaderAnimationHide());
            this.gettingDetailsLicense = false;
            this.gettingLDetailsLicenseError =
              'Hubo un problema  al obtener el detalle de Infracciones';
          },
          complete: () => {
            // segundo dispatch
            this.store.dispatch(loaderAnimationHide());
          },
        });
    }
    else {
      this.warning = true;
    }
  }

  getListNumberCount(pageCount: number) {
    const pagsArr: number[] = [];
    for (let i = 0; i < pageCount; i++) {
      pagsArr.push(i + 1);
      this.listCountForPages = pagsArr;
    }
  }

  getNextpage() {
    const currentPage = this.pageNumberSelected.value;
    if (currentPage) {
      this.pageNumberSelected.setValue(currentPage + 1);
      this.onGetDetailReport(this.lastSubmitData);

    }
  }
  getPreviusPage() {
    this.pageNumberSelected.setValue(this.currentPage - 1);
    this.onGetDetailReport(this.lastSubmitData);
  }

  getGotoNumberPage(numberPageSelected: number) {
    if (numberPageSelected) {
      this.pageNumberSelected.setValue(numberPageSelected);
      this.onGetDetailReport(this.lastSubmitData);
    }
  }

  exportToExcel() {
    type Keys = keyof ResponseInfringementsExcel;
    const headers: Record<Keys, string> = {
      names: 'Nombres',
      lastnames: 'Apellidos',
      rut: 'Rut',
      email: 'Correo',
      gender: 'Género',
      emergencyContact: 'Contacto de Emergencia',
      emergencyPhoneNumber: 'Número de Emergencia (Fijo)',
      adress: 'Dirección',
      management: 'Gerencia',
      entityType: 'Empleado / Contratista',
      company: 'Empresa',
      businessUnit: 'Unidad de Negocio',
      charge: 'Cargo',
      shiftSystem: 'Sistema Turno',
      infringementNumber: 'Número de Infracción',
      infringementState: 'Estado',
      infringementSite: 'Sitio de Infracción',
      zone: 'Zona',
      vehicle: 'Vehículo',
      vehiclePatent: 'Patente',
      infringementDateTime: 'Fecha y Hora Infracción',
      oneUpInfringementName: 'Nombre Gerente del Infractor',
      oneUpInfringementRut: 'Rut Gerente del Infractor',
      oneUpInfringementEmail: 'Correo Gerente del Infractor',
      infringementSeverity: 'Severidad de Infracción',
      infringementType: 'Tipo de Infracción',
      infringementObservation: 'Observación de Infracción',
      reportedBy: 'Reportado por',
      sanctionType: 'Tipo de Sanción',
      sanctionStart: 'Inicio Sanción',
      sanctionEnd: 'Fin Sanción',
      suspensionDays: 'Días de Suspensión',
    };
    if (this.lastSubmitData) {
      this.store.dispatch(loaderAnimationShow());
      this.reportsServices
        .getReportInfringementsToExcel(this.lastSubmitData)
        .subscribe({
          next: (dataToExcel) => {
            const dataWithDateParsed = dataToExcel.map((data) => ({
              ...data,
              infringementDateTime: data.infringementDateTime ? dateTimeToString(data.infringementDateTime) : '',
              sanctionStart: data.sanctionStart ? dateToString(data.sanctionStart) : '',
              sanctionEnd: data.sanctionEnd ? dateToString(data.sanctionEnd) : '',
            }));
            exportToExcel(headers, dataWithDateParsed as any, 'Infracciones ');
            this.store.dispatch(loaderAnimationHide());
          },
        });
    }
  }

  onCheckAssetChange(value: Array<{ id: number; active: boolean }>) {
    this.assetIdSelectedControl.setValue(
      value.filter(({ active }) => active).map(({ id }) => id)
    );
  }
}
